import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Tabs } from "antd";
import {
  EventImageReports,
  EventOverview,
  EventPhotos,
  EventSettings,
  EventUsers,
} from "./Details";
import { LeftOutlined } from "@ant-design/icons";
import EventWatermark from "./Details/EventWatermark";
import { useSelector } from "react-redux";
import { GetEventDetailService } from "../../../apis/events";

export default function ManageEvents() {
  const { id, tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backUrl = location.state?.from || "/app/events";
  const [title, setTitle] = useState("");
  const { user } = useSelector((state) => state.auth);

  // The page title used to be set only by EventOverview (a lazily-mounted
  // tab pane) — refreshing/landing directly on a non-Overview tab, or a
  // browser session where Overview never activated, left it blank. Fetching
  // it here, independent of which tab is active, keeps it reliable.
  useEffect(() => {
    let cancelled = false;
    const fetchTitle = async () => {
      try {
        const res = await GetEventDetailService({ id });
        if (!cancelled && res.status === 200 && res.data?.success) {
          setTitle(res.data.event?.event_name || "");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchTitle();
    return () => {
      cancelled = true;
    };
  }, [id]);

  const tabsList = [
    {
      key: "overview",
      label: "Overview",
      children: <EventOverview setTitle={setTitle} />,
    },
    {
      key: "users",
      label: "Users",
      children: <EventUsers />,
    },
    {
      key: "photos",
      label: "Photos",
      children: <EventPhotos />,
    },
    {
      key: "reports",
      label: "Reports",
      children: <EventImageReports />,
    },
    { key: "watermark", label: "Watermark", children: <EventWatermark /> },
    ...(user?.user_type === "admin" || ['eventapp', 'tktplz'].includes(user?.source)
      ? [{ key: "setting", label: "Settings", children: <EventSettings /> }]
      : []),
  ];

  const isAutoLogin = sessionStorage.getItem('from_auto_login') === '1';

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        {!isAutoLogin && (
          <Link to={backUrl} className="page-title">
            <LeftOutlined /> {title}
          </Link>
        )}
        {isAutoLogin && <span className="page-title">{title}</span>}
        {!isAutoLogin && (
          <Button
            iconPosition="end"
            icon={<i className="fa-solid fa-arrow-up-right"></i>}
            onClick={() => navigate("/app/events")}
          >
            Event Page
          </Button>
        )}
      </div>
      <Tabs
        defaultActiveKey={tab}
        items={tabsList}
        onChange={(key) => navigate(`/app/events/manage/${id}/${key}`)}
      />
    </>
  );
}
